import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface TopbarContent {
  title: string;
  sub?: ReactNode;
  actions?: ReactNode;
}

export const TopbarContext = createContext<{
  content: TopbarContent | null;
  setContent: (c: TopbarContent | null) => void;
}>({ content: null, setContent: () => {} });

export function useTopbarState() {
  const [content, setContent] = useState<TopbarContent | null>(null);
  return { content, setContent };
}

/**
 * Stránka si nastaví titulok topbaru (a `document.title`) — shell nemusí
 * vedieť o každej ceste. Pri odchode zo stránky sa titulok vyprázdni.
 */
export function PageTitle({ title, sub, actions }: TopbarContent) {
  const { setContent } = useContext(TopbarContext);
  useEffect(() => {
    document.title = `${title} · Ametica Watcher`;
    setContent({ title, sub, actions });
    return () => setContent(null);
  }, [title, sub, actions, setContent]);
  return null;
}
